import { IVR_API_URL } from "./ivr.url";

export const getIvrDetails = async () => {
  const response = await fetch(`${IVR_API_URL}`);
  const res = await response.json();
  return res;
};
